import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ENVIRONMENT } from '@/config-global';
import { useTheme } from '@mui/material/styles';
import Iconify from '../../media/iconify';

export function EnvIcon() {
  const themeGlobal = useTheme();

  if (!ENVIRONMENT || ENVIRONMENT === 'production') {
    return null;
  }

  return (
    <Box
      sx={{
        right: 0,
        transform: 'translateX(0%)',
        bottom: 0,
        width: 'auto',
        zIndex: themeGlobal.zIndex.appBar + 2,
        display: 'flex',
        position: 'fixed',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'text.primary',
        bgcolor: '#e1234e',
        padding: (theme) => theme.spacing(0.45, 0.9),
        boxShadow: (theme) => theme.customShadows.dropdown,
        borderTopLeftRadius: 5,
      }}
    >
      <Iconify icon="skill-icons:nestjs-light" sx={{ mr: 0.9 }} width={10} height={10} />{' '}
      <Typography sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.5rem' }}>
        ENVIRONMENT: {ENVIRONMENT}
      </Typography>
    </Box>
  );
}
